<section class="content" [innerHTML]="infoPanel">
</section>
